import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import * as CONSTANTS from "../CONSTANTS";
import TopNavigation from '../Components/navigation/TopNavigation';
import bannerHero from './../assets/honeymoon01.png';
import { Parser } from 'html-to-react';
import transition from '../transition';
import MainFooter from '../Components/footer/MainFooter';
import { Helmet } from 'react-helmet';

function SingleDripp() {
    const params                                                       = useParams();

    const [currentEvent, setCurrentEvent]                              = useState();

    const htmlParser                                                   = new Parser();

    const [popupImage, setPopupImage]                                  = useState(null);

    useEffect(() => {     
        collectCurrentDripp();
    }, []);

    const collectCurrentDripp = async () => {
      try{
  
        const res = await axios.get(CONSTANTS.API_URL +"annivites/v1/dripp/index/" + params.id);
        setCurrentEvent(res.data);       
      }catch (err) {
          console.log(err);        
      }   
    }

  return (
    <div className="main-layer">
        <Helmet>
            <title>Lovedripp - Dripp </title>
        </Helmet> 
        <TopNavigation title={"Dripps"} classBack="full-white"/>
        <div className="content-layer">
            <div className="banner-photo-show middle-align txt-white" 
                style={{backgroundImage: `url("${bannerHero}")`}}>     
                <div className="info-hero-intro up-more-7">
                  
                    {
                        currentEvent && (
                               <div className="sub-text-hero"> 
                                    {htmlParser.parse(currentEvent.experience)}
                                </div>
                        )
                    }                 
                </div>                 
            </div>
            <div className="space-bit">
                {
                    currentEvent &&
                    currentEvent.imageList.length > 0 && (
                        <div className="gallery-Masonry">
                            {
                                currentEvent.imageList.map((image, index) => {
                                    return <div className="layout-item" key={index}>
                                              <div 
                                                 className="img-wrap phCount"                                                 
                                                >
                                                <img 
                                                    src={image.imageUrl} 
                                                    className="single-image"
                                                     alt={"Lovedripp Annivite - " + currentEvent.spouseA + " " + currentEvent.spouseB} 
                                                    onClick={() => setPopupImage(image.imageUrl)}
                                                    />
                                              </div>
                                           </div>
                                })
                            }
                        </div>
                    )
                }
                {
                    popupImage && (
                        <div className="popup-overlay" onClick={() => setPopupImage(null)}>
                            <div className="popup-content" onClick={(e) => e.stopPropagation()}>
                                <img src={popupImage} alt="Event Dripp" />
                                <button className="close-button" onClick={() => setPopupImage(null)}>×</button>
                            </div>
                        </div>
                    )
                }
            </div>
            <div className="section-item text-center">
                {
                    currentEvent && (
                        <div className="return-view">

                            <Link 
                                className="btn btn-main btn-inlarge"
                                to={"/couple-event/" + currentEvent.annisiteId}>
                                    Couple Annisite
                            </Link>
                        </div>
                    )
                }
                
            </div>
        </div>
        <MainFooter />
    </div>
  )
}

export default transition(SingleDripp)